module.exports = __webpack_public_path__ + "img/products_big_can_orange.28c7d6f8.png";